import { motion } from "framer-motion";
import React from "react";
import { useLanguage } from "../context/LanguageContext";

const Experience = () => {
	const { t } = useLanguage();

	const experiences = [
		{
			role: "roles.role1",
			company: "companies.company1",
			duration: "Feb 2025 - May 2025",
			description: "descriptions.desc1",
		},
		{
			role: "roles.role2",
			company: "companies.company2",
			duration: "Sept 2024 - " + t("present"),
			description: "descriptions.desc2",
		},
		{
			role: "roles.role3",
			company: "companies.company3",
			duration: "Oct 2023 - " + t("present"),
			description: "descriptions.desc3",
		},
		{
			role: "roles.role4",
			company: "companies.company4",
			duration: "Sept 2022 - Dec 2023",
			description: "descriptions.desc4",
		},
		{
			role: "roles.role5",
			company: "companies.company5",
			duration: "Aug 2022 - Jan 2023",
			description: "descriptions.desc5",
		},
		{
			role: "roles.role6",
			company: "companies.company6",
			duration: "August 2021",
			description: "descriptions.desc6",
		},
		{
			role: "roles.role7",
			company: "companies.company7",
			duration: "2018-2020",
			description: "descriptions.desc7",
		},
	];

	return (
		<section
			id="experience"
			className="py-20 bg-gray-50 dark:bg-gray-800">
			<div className="container mx-auto px-4">
				<motion.div
					initial={{ opacity: 0, y: 20 }}
					whileInView={{ opacity: 1, y: 0 }}
					viewport={{ once: true }}
					transition={{ duration: 0.5 }}>
					<h2 className="text-3xl font-bold text-center mb-2">
						{t("experienceTitle")}
					</h2>
					<p className="text-xl text-center mb-12 text-gray-600 dark:text-gray-400">
						{t("experienceSubtitle")}
					</p>

					<div className="max-w-3xl mx-auto">
						<div className="relative pl-8 border-l-2 border-blue-500 dark:border-blue-400 space-y-12">
							{experiences.map((exp, index) => (
								<ExperienceItem
									key={index}
									role={t(exp.role)}
									company={t(exp.company)}
									duration={exp.duration}
									description={t(exp.description)}
									delay={index * 0.2}
								/>
							))}
						</div>
					</div>
				</motion.div>
			</div>
		</section>
	);
};

const ExperienceItem = ({ role, company, duration, description, delay }) => {
	return (
		<motion.div
			initial={{ opacity: 0, x: -20 }}
			whileInView={{ opacity: 1, x: 0 }}
			viewport={{ once: true }}
			transition={{ duration: 0.5, delay }}
			className="relative">
			<div className="absolute -left-[42px] h-6 w-6 rounded-full bg-blue-500 dark:bg-blue-400 flex items-center justify-center">
				<div className="h-3 w-3 rounded-full bg-white"></div>
			</div>
			<h3 className="text-xl font-bold">{role}</h3>
			<div className="text-blue-600 dark:text-blue-400 font-medium mb-1">
				{company}
			</div>
			<p className="text-sm text-gray-500 dark:text-gray-400 mb-3">
				{duration}
			</p>
			<p className="text-gray-700 dark:text-gray-300">{description}</p>
		</motion.div>
	);
};

export default Experience;
